import React from 'react';
import LineChartCard from './LineChartCard';
import LineChartSkeleton from '../../views/dashboard/skeletons/LineChartSkeleton';
import useStatistics from '../../hooks/data/useStatistics';

export default function LineChartGrid({ className }) {
  const { metrics, isLoading, getMetricLabel, getMetric, dateRangeFilter } = useStatistics();

  const isAllFilter = !dateRangeFilter?.start_date && !dateRangeFilter?.end_date && !dateRangeFilter?.period;

  function renderMetric(item) {
    if (isLoading(item.route)) {
      return (
        <div key={item.metric}>
          <LineChartSkeleton title={getMetricLabel(item.metric)} />
        </div>
      );
    }

    return (
      <div key={item.metric}>
        <LineChartCard
          metric={item.metric}
          title={getMetricLabel(item.metric)}
          data={getMetric(item.metric)}
          hasTimeLine={!isAllFilter}
        />
      </div>
    );
  }

  return (
    <div className={className ?? 'grid lg:grid-cols-3 grid-cols-1 gap-4 mt-md'}>
      {metrics.map((item) => renderMetric(item))}
    </div>
  );
}
